export default function getLocationParams(location) {
    if (location.pathname) {
        const paths = location.pathname.split('/');

        if (paths.length > 2) {
            // For tours, /ticket/{parent_id}/ticket/{id}
            if (paths[1] === 'ticket' && paths.length > 4) {
                return { location_id: paths[4], location_type: 'Ticket Facility' };
            }

            // For ticket facilities, /ticket/facility/{id}
            if (paths[1] === 'ticket' && paths.length > 3) {
                return { location_id: paths[3], location_type: 'Ticket Facility' };
            }

            if (paths[1] === 'camping' && paths.length > 3) {
                // For rec areas, /camping/gateways/{id}
                if (paths[2] === 'gateways') {
                    return { location_id: paths[3], location_type: 'Rec Area' };
                }

                // For camping, /camping/campground/{id}
                return { location_id: paths[3], location_type: 'Campground' };
            }

            // For timed entry, /timed-entry/{id}
            if (paths[1] === 'timed-entry' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Timed Entry' };
            }

            // For tree permit /tree-permits/{id}
            if (paths[1] === 'tree-permits' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Tree Permit' };
            }

            // For activity pass /activitypass/{id}
            if (paths[1] === 'activitypass' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Activity Pass' };
            }

            // For site pass /sitepass/{id}
            if (paths[1] === 'sitepass' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Rec Area' };
            }

            // For vehicle permits, /vehiclepermits/{id}
            if (paths[1] === 'vehiclepermits' && paths.length > 2) {
                return { location_id: paths[2], location_type: 'Vehicle Permit' };
            }

            // For permits, /permits/{id}
            return { location_id: paths[2], location_type: 'Permit' };
        }
    }

    return null;
}
